<template>
  <v-autocomplete
    :items="consultants"
    item-value="id"
    item-text="fullName"
    v-model="consultantIdValue"
    label="Consultant"
    :clearable="clearable ? clearable : false"
    :readonly="readonly"
    :disabled="disabled"
    :rules="[requiredCheck()]"
    :dense="dense"
    :hide-details="hideDetails ? hideDetails : false"
    outlined
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'value',
    'clientId',
    'assignments',
    'isRequired',
    'readonly',
    'disabled',
    'clearable',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      fetchedConsultants: []
    }
  },
  computed: {
    // When the caller already fetched the client's assignments (e.g. it also needs
    // job titles), use those directly instead of issuing a second, redundant
    // getAssignments call for the same clientId.
    consultants () {
      return this.assignments ? this.buildConsultantOptions(this.assignments) : this.fetchedConsultants
    },
    consultantIdValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
        this.$emit('consultantIdChange', newValue)
      }
    }
  },
  watch: {
    clientId () {
      // Clear the selected consultant when the client changes,
      // and fetch the new list of consultants for the new client
      this.consultantIdValue = null
      if (!this.assignments) {
        this.fetchClientConsultants()
      }
    }
  },
  methods: {
    ...mapActions('assignments', [
      'getAssignments'
    ]),
    buildConsultantOptions (assignments) {
      const consultantOptions = assignments.map(assignment => ({
        id: assignment.userId,
        fullName: assignment.userFullName
      }))
      return [...new Map(consultantOptions.map(consultant => [consultant.id, consultant])).values()]
    },
    fetchClientConsultants () {
      if (this.clientId !== null && this.clientId !== undefined) {
        const requestedClientId = this.clientId
        this.getAssignments({ clientId: requestedClientId }).then((assignments) => {
          if (this.clientId !== requestedClientId) {
            return
          }

          this.fetchedConsultants = this.buildConsultantOptions(assignments)
        })
      } else {
        this.fetchedConsultants = []
      }
    },
    requiredCheck () {
      return !this.isRequired || required('Consultant')
    }
  },
  created () {
    if (!this.assignments) {
      this.fetchClientConsultants()
    }
  }
}
</script>
